<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4" :lg="4">
          <el-input placeholder="会员账号" v-model="member_account" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="4" :lg="4">
          <el-input placeholder="提现账号" v-model="account_number" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选提现’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>

      <div class="recharge-overview view-flex content-center content-padded" style="width: 40%;">
        <div class="view-flex-item">
          <i class="iconfont icon-donate"></i>
          <div><span>{{amount_total_des}}</span> <span class="money mark">{{amount_total}}</span> 元</div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-credit-card1"></i>
          <div>{{jiesuan_total_des}} <span class="money mark">{{jiesuan_total}}</span> 条</div>
        </div>
      </div>

      <el-row>
        <el-col :span="12">
          <el-button-group v-if="tab_status=='daishen'">
            <el-button size="mini" type="primary" icon="plus" @click="shenhe">批量审核</el-button>
          </el-button-group>
          <el-button-group v-if="tab_status=='daijie'">
            <el-button size="mini" type="primary" icon="plus" @click="jiesuan">批量结算</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-tabs type="border-card" v-model="tab_status" @tab-click="handleClick">
        <el-tab-pane label="待审核" name="daishen"></el-tab-pane>
<!--        <el-tab-pane label="待结算" name="daijie"></el-tab-pane>-->
        <el-tab-pane label="已结算" name="yijie"></el-tab-pane>
<!--        <el-tab-pane label="审核未通过" name="weitong"></el-tab-pane>-->
        <el-tab-pane label="结算失败" name="jieshi"></el-tab-pane>
      <el-table :data="withdrawData" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
<!--        <el-table-column prop="id" label="ID" width="95"></el-table-column>-->
        <el-table-column prop="user_id" label="怡贝会员ID" width="95"></el-table-column>
        <el-table-column prop="member_account"   label="会员账号" width="130"></el-table-column>
        <el-table-column prop="account_number"   label="提现账号" width="130"></el-table-column>
        <el-table-column prop="amount"  label="提现金额" width="90"></el-table-column>
<!--        <el-table-column prop="amount_before"  label="提现前余额" width="90"></el-table-column>-->
<!--        <el-table-column prop="amount_after"  label="提现后余额" width="90"></el-table-column>-->
        <el-table-column prop="name"  label="真实姓名" width="80"></el-table-column>
        <el-table-column prop="order_id"  label="订单号" width="150"></el-table-column>
        <el-table-column prop="approval_status" label="状态" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.approval_status!='1'">
              <el-tag v-if="scope.row.approval_status=='1'">审核通过</el-tag>
              <el-tag v-else-if="scope.row.approval_status=='2'" type="info">审核未通过</el-tag>
              <el-tag v-else type="danger">等待审核</el-tag>
            </div>
            <div v-else>
              <el-tag v-if="scope.row.billing_status=='1'">已结算</el-tag>
              <el-tag v-else-if="scope.row.billing_status=='2'" type="info">结算失败</el-tag>
              <el-tag v-else type="warning" @click="editInfo2(scope.row)">等待结算</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="add_time" label="申请时间" width="250" v-if="tab_status=='daishen'">
          <template slot-scope="scope" v-if="tab_status=='daishen'">
            {{scope.row.add_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="审核时间" width="250" v-if="tab_status=='daijie' || tab_status=='weitong'">
          <template slot-scope="scope" v-if="tab_status=='daijie' || tab_status=='weitong'">
            {{scope.row.update_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="directions"  label="审核说明" width="80" v-if="tab_status=='daijie' || tab_status=='weitong'"></el-table-column>
        <el-table-column prop="payed_time" label="转账时间" width="250" v-if="tab_status=='yijie' || tab_status=='jieshi'">
          <template slot-scope="scope" v-if="(tab_status=='yijie' || tab_status=='jieshi') && scope.row.payed_time">
            {{scope.row.payed_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
          <template slot-scope="scope" v-else>

          </template>
        </el-table-column>
        <el-table-column prop="scon"  label="结算说明" width="150" v-if="tab_status=='yijie' || tab_status=='jieshi'"></el-table-column>
       <el-table-column label="操作" width="130" v-if="tab_status=='daishen'">
        <template slot-scope="scope"  v-if="tab_status=='daishen'">
          <el-tag><i class="iconfont mobile-editor" @click="editInfo(scope.row)">去审核</i></el-tag>
        </template>
       </el-table-column>
        <el-table-column label="操作" width="130" v-if="tab_status=='daijie'">
          <template slot-scope="scope" v-if="tab_status=='daijie'">
            <el-tag><i class="iconfont mobile-editor" @click="editInfo2(scope.row)">去结算</i></el-tag>
          </template>
        </el-table-column>
      </el-table>
      </el-tabs>

      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>


      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="提现金额">
<!--            <el-input v-model="updateForm.amount" placeholder="提现金额" disabled></el-input>-->
            <span>{{updateForm.amount}}</span>
          </el-form-item>
          <el-form-item label-width="100px" label="审核说明">
            <el-input v-model="updateForm.directions" placeholder="审核说明"></el-input>
          </el-form-item>
<!--          <el-form-item label-width="100px" label="结算说明">-->
<!--            <el-input v-model="updateForm.scon" placeholder="结算说明"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label-width="100px" label="审核状态">
          <el-radio-group v-model="updateForm.approval_status" size="small" @change="changeStatus">
            <el-radio-button :label="'0'">等待审核</el-radio-button>
            <el-radio-button :label="'1'">通过</el-radio-button>
            <el-radio-button :label="'2'">未通过</el-radio-button>
          </el-radio-group>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" :loading="btnLoading" @click="examineSubmit()" v-if="updateForm.approval_status=='1'">确定结算</el-button>
            <el-button type="primary" :loading="btnLoading" @click="examineSubmit()" v-else>确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

      <el-dialog  title="批量审核" class="right-dialog" :visible.sync="shenheDialog" :before-close="shenheDialogClose">
        <template>
          <el-form>
            <el-form-item label-width="100px" label="选中总条数">
<!--              <el-input v-model="num" placeholder="选中总条数" disabled></el-input>-->
              <span>{{num}}</span>
            </el-form-item>
            <el-form-item label-width="100px" label="选中总金额">
<!--              <el-input v-model="amount" placeholder="选中总金额" disabled></el-input>-->
              <span>{{amount}}</span>
            </el-form-item>
            <el-form-item label-width="100px" label="审核说明">
              <el-input v-model="directions" placeholder="审核说明"></el-input>
            </el-form-item>
<!--            <el-form-item label-width="100px" label="结算说明">-->
<!--              <el-input v-model="scon" placeholder="结算说明"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label-width="100px" label="审核状态">
              <el-radio-group v-model="approval_status" size="small" @change="changeStatus2">
                <el-radio-button :label="'0'">等待审核</el-radio-button>
                <el-radio-button :label="'1'">通过</el-radio-button>
                <el-radio-button :label="'2'">未通过</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" :loading="btnLoading" @click="shenheSubmit()" v-if="approval_status=='1'">确定结算</el-button>
              <el-button type="primary" :loading="btnLoading" @click="shenheSubmit()" v-else>确定</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-dialog>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {
  withdrawList,
  withdrawExamine,
  withdrawSettlement,
  withdrawExport,
  withdrawShenhe,
  withdrawJiesuan
} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      id: [],
      directions: '',
      approval_status: 0,
      scon: '',
      amount: 0,
      num: 0,
      total_count: 0,
      dialogTitle: '',
      dialogTitle2: '',
      loading: false,
      exportLoading: false,
      btnLoading: false,
      withdrawData: [],
      tab_status: 'daishen',
      params: {
        page: 1,
        pageSize: 20,
        tab_status: 'daishen'
      },
      updateForm: {
        amount: '',
        approval_status: '',
        billing_status: '',
        directions: '',
        scon: ''
      },
      amount_total: 0.00,
      jiesuan_total: 0,
      amount_total_des: '待结算金额',
      jiesuan_total_des: '待结算条数',
      editInfoDialog: false,
      editInfoDialog2: false,
      shenheDialog: false,
      jiesuanDialog: false,
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      member_account: '',
      account_number: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getWithdrawList (filter) {
      this.loading = true
      withdrawList(filter).then(response => {
        this.withdrawData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.amount_total = response.data.data.jiesuanResult.amount_total
        this.jiesuan_total = response.data.data.jiesuanResult.jiesuan_total
        this.loading = false
        this.exportLoading = false
      })
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      this.updateForm.id = row.id
      this.updateForm.amount = row.amount
      this.updateForm.approval_status = row.approval_status
      this.updateForm.billing_status = row.billing_status
      this.updateForm.directions = ''
      this.updateForm.scon = ''
      this.dialogTitle = '提现审核'
    },
    editInfo2 (row = '') {
      this.editInfoDialog2 = true
      this.updateForm.id = row.id
      this.updateForm.amount = row.amount
      this.updateForm.scon = ''
      this.dialogTitle2 = '提现结算'
    },
    changeStatus (value) {
      if (value == 1) {
        this.updateForm.directions = '审核通过'
        // this.updateForm.scon = '等待结算'
        this.updateForm.scon = ''
      } else if (value == 2) {
        this.updateForm.directions = '审核未通过'
        this.updateForm.scon = '结算失败'
      } else {
        this.updateForm.directions = ''
        this.updateForm.scon = ''
      }
    },
    changeStatus2 (value) {
      if (value == 1) {
        this.directions = '批量操作，审核通过'
        // this.scon = '等待结算'
        this.scon = ''
      } else if (value == 2) {
        this.directions = '批量操作，审核未通过'
        this.scon = '结算失败'
      } else {
        this.directions = ''
        this.scon = ''
      }
    },
    examineSubmit () {
      if (this.updateForm.approval_status == '0') {
        this.$message({
          type: 'error',
          message: '请选择审核状态'
        })
        return
      }
      let paramsShenhe = {}
      paramsShenhe = {
        id: this.updateForm.id,
        approval_status: this.updateForm.approval_status,
        directions: this.updateForm.directions,
        scon: this.updateForm.scon
      }
      this.btnLoading = true
      withdrawShenhe(paramsShenhe).then(res => {
        if (res.data.code) {
          this.$message({type: 'success', message: '审核成功'})
          this.editInfoDialog = false
          this.btnLoading = false
          this.getWithdrawList(this.params)
        }
      })
    },
    // settlementSubmit () {
    //   this.btnLoading = true
    //   withdrawSettlement({id: this.updateForm.id, scon: this.updateForm.scon}).then(res => {
    //     this.$message({ type: 'success', message: '结算成功'})
    //     this.editInfoDialog2 = false
    //     this.btnLoading = false
    //     this.getWithdrawList(this.params)
    //   })
    // },
    // 切换tab
    handleClick (tab, event) {
      this.tab_status = tab.name
      this.params.tab_status = tab.name
      this.params.page = 1
      // this.member_account = ''
      // this.created = ''
      // this.params.member_account = ''
      // this.params.time_start_begin = ''
      // this.params.time_start_end = ''
      if (tab.name == 'daishen') {
        this.amount_total_des = '待结算金额'
        this.jiesuan_total_des = '待结算条数'
      }else if (tab.name == 'yijie') {
        this.amount_total_des = '已结算金额'
        this.jiesuan_total_des = '已结算条数'
      }else{
        this.amount_total_des = '结算失败金额'
        this.jiesuan_total_des = '结算失败条数'
      }
      this.getWithdrawList(this.params)
    },
    getParams () {
      this.params.member_account = this.member_account
      this.params.account_number = this.account_number
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getWithdrawList(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getWithdrawList(this.params)
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      withdrawExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选提现中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    },
    shenhe () {
      this.approval_status = 0
      this.directions = ''
      this.scon = ''
      this.storeItemsList = []
      if (this.id.length) {
        this.shenheDialog = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个记录'
        })
      }
    },
    // jiesuan () {
    //   this.storeItemsList = []
    //   if (this.id.length) {
    //     this.jiesuanDialog = true
    //   } else {
    //     this.$message({
    //       type: 'error',
    //       message: '请选择至少一个记录'
    //     })
    //   }
    // },
    shenheSubmit () {
      if (!this.approval_status) {
        this.$message({
          type: 'error',
          message: '请选择审核状态'
        })
        return
      }
      let paramsShenhe = {}
      paramsShenhe = {
        id: this.id,
        approval_status: this.approval_status,
        directions: this.directions,
        scon: this.scon
      }
      this.btnLoading = true
      withdrawShenhe(paramsShenhe).then(res => {
        if (res.data.code) {
          this.$message({ type: 'success', message: '批量审核成功'})
          this.shenheDialog = false
          this.btnLoading = false
          this.getWithdrawList(this.params)
        }
      })
    },
    // jiesuanSubmit () {
    //   let paramsShenhe = {}
    //   paramsShenhe = {
    //     id: this.id,
    //     scon: this.scon
    //   }
    //   this.btnLoading = true
    //   withdrawJiesuan(paramsShenhe).then(res => {
    //     if (res.data.code) {
    //       this.$message({ type: 'success', message: '批量结算成功'})
    //       this.jiesuanDialog = false
    //       this.btnLoading = false
    //       this.getWithdrawList(this.params)
    //     }
    //   })
    // },
    shenheDialogClose () {
      this.shenheDialog = false
    },
    jiesuanDialogClose () {
      this.jiesuanDialog = false
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    handleCancelLabelsDialog2 () {
      this.editInfoDialog2 = false
    },
    handleSelectionChange (val) {
      this.amount = 0
      let id = []
      for (let i in val) {
        id.push(val[i].id)
        this.amount += Number(val[i].amount)
      }
      this.id = id
      this.num = val.length
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getWithdrawList(this.params)
    }
  },
  mounted () {
    this.getWithdrawList(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    withdrawData: {
      handler (value) {
        if (this.allCheck) {
          this.withdrawData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
.recharge-overview {
  .iconfont {
    font-size: 30px;
    color: #ff5000;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?18106216